import { api } from "@/lib/api";

/**
 * Fetch a protected /api/files/<path> resource with authenticated axios,
 * convert to a blob URL and open it in a new tab. Works for coach (cookie
 * session) and learner (X-Learner-Token via interceptor).
 */
export async function openStorageFile(filePath, originalFilename) {
  try {
    const { data, headers } = await api.get(`/files/${filePath}`, { responseType: "blob" });
    const type = headers?.["content-type"] || data.type || "application/octet-stream";
    const blob = new Blob([data], { type });
    const url = URL.createObjectURL(blob);
    const win = window.open(url, "_blank", "noopener,noreferrer");
    // Firefox iOS may block popups — fallback to anchor download
    if (!win) {
      const a = document.createElement("a");
      a.href = url;
      a.download = originalFilename || filePath.split("/").pop();
      a.click();
    }
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch (e) {
    const status = e?.response?.status;
    throw new Error(status ? `Erreur ${status}` : "Impossible d'ouvrir le fichier");
  }
}
